module.exports = __webpack_public_path__ + "media/images/sp/stores/fuji/fuji_sns_06-90eb75ec40660a8bb98d31e22d6d1388.jpg";